import React from "react";

import {
  Card,
  CardBody,
  CardTitle,
  Content,
  Grid,
  GridItem,
  Icon,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  CodeIcon,
  CogIcon,
  DatabaseIcon,
  DesktopIcon,
  NetworkWiredIcon,
  ServerIcon
} from "@patternfly/react-icons";


const skillIcons = {
  hardware: DesktopIcon,
  "operating-systems": CogIcon,
  "computer-networks": NetworkWiredIcon,
  servers: ServerIcon,
  databases: DatabaseIcon,
  "web-technologies": CodeIcon
};


const EducationDirectionSkills = ({
  skills = []
}) => {
  if (!skills.length) {
    return null;
  }

  return (
    <PageSection
      id="skills"
      className="education-direction-section"
      isWidthLimited
      aria-labelledby="education-direction-skills-title"
    >
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Content
                style={{
                  textAlign: "center"
                }}
              >
                <h2 id="education-direction-skills-title">
                  Czego się nauczysz?
                </h2>

                <p>
                  Nauka łączy wiedzę techniczną
                  z praktycznymi umiejętnościami
                  wykorzystywanymi w pracy zawodowej.
                </p>
              </Content>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid hasGutter>
            {skills.map((skill) => {
              const SkillIcon = skillIcons[skill.id];

              return (
                <GridItem
                  key={skill.id}
                  span={12}
                  sm={6}
                  lg={4}
                >
                  <Card
                    isGlass
                    isFullHeight
                  >
                    <CardTitle>
                      <Stack hasGutter>
                        {SkillIcon && (
                          <StackItem>
                            <Icon
                              size="xl"
                            //   status="danger"
                            >
                              <SkillIcon />
                            </Icon>
                          </StackItem>
                        )}

                        <StackItem>
                          <Content>
                            <h3>{skill.title}</h3>
                          </Content>
                        </StackItem>
                      </Stack>
                    </CardTitle>

                    <CardBody>
                      <Content>
                        <p>{skill.description}</p>
                      </Content>
                    </CardBody>
                  </Card>
                </GridItem>
              );
            })}
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};


export default EducationDirectionSkills;